<div class="flex flex-column gap-3 md:w-25rem">
  <h3 class="m-0"
      i18n>Thema list</h3>

  @if (hintText) {
    <span class="text-color-secondary">{{ hintText }}</span>
  }

  @if ((themaGroups$ | async); as themaGroups) {
    <p-accordion [multiple]="true">
      @for (group of themaGroups; track group.parent.code) {
        <p-accordion-panel [value]="group.parent.code">
          <p-accordion-header>[{{ group.parent.code }}] {{ group.parent.heading }}</p-accordion-header>
          <p-accordion-content>
            <div class="flex flex-column gap-3">
              @for (thema of group.children; track thema.code) {
                <div class="flex align-items-center">
                  <p-checkbox name="themas"
                              [value]="thema.code"
                              [ngModel]="selected"
                              (ngModelChange)="onSelectedChange($event)"
                              [disabled]="disabled"
                              [inputId]="'thema-' + thema.code">
                  </p-checkbox>
                  <label [for]="'thema-' + thema.code"
                         class="ml-2">[{{ thema.code }}] {{ thema.heading }}</label>
                </div>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  }
</div>